import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getNewPackages, deleteNewPackage } from "../../../actions/admin/package";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";
import AdminTable from "../_components/AdminTable";
import AdminDeleteModal from "../_components/AdminDeleteModal";
import NewPackageItem from "./NewPackageItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Package Name", width: "tw:w-[260px]" },
  { key: "description", title: "Description", width: "tw:w-[420px]" },
  { key: "type", title: "Type", width: "tw:w-[200px]", skeleton: "badge" },
  { key: "status", title: "Status", width: "tw:w-[160px]", skeleton: "badge" },
  { key: "action", title: "Action", width: "tw:w-[140px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const NewPackageList = () => {
  const trippackage = useSelector((state) => state.trippackage);
  const { loading, tnewpackages } = trippackage;
  const [delId, setDelId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNewPackages());
  }, [dispatch]);

  const delPkgfromPopup = () => {
    dispatch(deleteNewPackage(delId));
    setDelId(null);
  };

  return (
    <AdminPage title="Package List" actions={<AdminCreateButton to="/admin/addpackage" label="Add Package" />}>
      <AdminDeleteModal
        show={!!delId}
        title="Delete this package?"
        message="This cannot be undone."
        onCancel={() => setDelId(null)}
        onConfirm={delPkgfromPopup}
      />

      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1240}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!tnewpackages?.length}
        emptyText="No packages found."
      >
        {tnewpackages?.map((item, index) => (
          <NewPackageItem key={item._id} package={item} count={index} deletePackage={setDelId} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default NewPackageList;
